import * as React from 'react';

import type { MaterialTopTabAnimationContext } from '../types';

export const TabAnimationContext = React.createContext<MaterialTopTabAnimationContext | undefined>(
  undefined
);
